import { FormControl } from '@angular/forms';

export function validEmail(control: FormControl) {
  const EMAIL_REGEXP = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/;
  const re = new RegExp(EMAIL_REGEXP);

  return re.test(control.value) || (control.value === '' || control.value == null) ? null : {
    validEmail: {
      valid: false,
    },
  };
}
